export const ActionTypes = {
    CURRENT_PAGE: "ui@CURRENT_PAGE"
};
